import { Calendar, DateObj } from 'dayzed';
import { useContext } from 'react';
import { DatePickerContext } from './context';

export default function DayPicker({
  calendar,
  onDateChange,
  date,
}: {
  calendar: Calendar;
  date?: Date;
  onDateChange: (d: Date) => void;
}) {
  return (
    <div className="grid grid-cols-7 text-sm place-content-start">
      {calendar.weeks.map((week, weekIndex) =>
        week.map((dateObj, index) => {
          let key = [calendar.month, calendar.year, weekIndex, index].join();

          if (!dateObj) {
            return <div key={key} />;
          }

          return <DayButton key={key} dateObj={dateObj} calendar={calendar} />;
        }),
      )}
    </div>
  );
}

function DayButton({
  dateObj,

  calendar,
}: {
  calendar: Calendar;
  dateObj: DateObj;
}) {
  const { selected, nextMonth, prevMonth } = dateObj;

  const { getDateProps } = useContext(DatePickerContext);

  const date = dateObj.date.getDate();

  if (!dateObj.selectable) {
    return (
      <div
        className={`p-2 text-center rounded border focus:outline-none border-white text-gray-700 bg-gray-light bg-opacity-10`}
      >
        {date}
      </div>
    );
  }
  return (
    <div
      {...getDateProps({ dateObj })}
      className={`p-2 text-center cursor-pointer rounded border border-white focus:outline-none
                        ${
                          selected
                            ? 'bg-green text-white'
                            : !prevMonth && !nextMonth
                            ? 'text-gray-dark hover:bg-gray-lighter hover:bg-opacity-10'
                            : 'text-gray-700 hover:bg-gray-lighter hover:bg-opacity-10'
                        }
                         `}
    >
      {date}
    </div>
  );
}
